export interface IFieldMeta {
  namespace: string;
  path: string;
  label: string;
  type: string;
  parent?: IFieldMeta;
  fields?: IFieldMeta[];
  associatedEntity?: string;
}

export type FieldMetaDataUnion = IBullhornFieldMeta | ISalesforceFieldMeta;

export interface IBullhornFieldMeta extends IFieldMeta {
  namespace: string;
  isPickerField?: boolean;
  options?: { value: string | number | boolean; label: string }[];
  dataSpecialization?: string;
  childrenOfComposite?: IBullhornFieldMeta[];
  optionsType?: string;
  multiValue?: boolean;
}

export interface ISalesforceFieldMeta extends IFieldMeta {
  isPickerField?: boolean;
  options?: { value: string | number | boolean; label: string }[];
  dataSpecialization?: string;
  childrenOfComposite?: ISalesforceFieldMeta[];
  optionsType?: string;
  multiValue?: boolean;
}

export interface IEntityMeta {
  namespace?: string;
  entity: string;
  label: string;
  fields: IFieldMeta[];
}

// which is best?
export interface IEntityTypeProperties {
  iconUrl?: string;
  iconColor?: string;
}

export type EntityTypeLabelPair = Pick<IEntityMeta, 'entity' | 'label'> & { properties?: IEntityTypeProperties };
// export type EntityTypeLabelPair2 = { entity: string, label: string };

export interface IMetaData {
  namespace: string;
  entities: IEntityMeta[];
}

/**
 * This is the entity name, used by *all* datasources, that represents the document sender
 */
export const DOCUMENT_SENDER_ENTITY_NAME = 'currentUser';
export const DOCUMENT_SENDER_ENTITY_LABEL_PAIR: EntityTypeLabelPair = {
  entity: DOCUMENT_SENDER_ENTITY_NAME,
  label: 'Document Sender',
};

/**
 * This is the entity name for the custom script fields.
 */
export const SCRIPT_FIELDS_ENTITY_NAME = 'kpScriptFields';
export const SCRIPT_FIELDS_ENTITY_NAME_LABEL_PAIR: EntityTypeLabelPair = {
  entity: SCRIPT_FIELDS_ENTITY_NAME,
  label: 'Script Fields',
};
export const SCRIPT_FIELDS_NAMESPACE = 'custom';
export const SCRIPT_FIELDS_MODEL_PATH = `${SCRIPT_FIELDS_NAMESPACE}.out`;

/**
 * This is the entity name for the image fields.
 */
export const IMAGE_FIELDS_ENTITY_NAME = 'kpImageFields';
export const IMAGE_FIELDS_ENTITY_NAME_LABEL_PAIR: EntityTypeLabelPair = {
  entity: IMAGE_FIELDS_ENTITY_NAME,
  label: 'Image Fields',
};

/**
 * This is the entity name for the conditional fields.
 */
export const CONDITIONAL_FIELDS_ENTITY_NAME = 'kpConditionalFields';
export const CONDITIONAL_FIELDS_ENTITY_NAME_LABEL_PAIR: EntityTypeLabelPair = {
  entity: CONDITIONAL_FIELDS_ENTITY_NAME,
  label: 'Conditional Fields',
};

/**
 * This is the entity name for the AI Assist fields.
 */
export const AIASSIST_FIELDS_ENTITY_NAME = 'kpAiAssistFields';
export const AIASSIST_FIELDS_ENTITY_NAME_LABEL_PAIR: EntityTypeLabelPair = {
  entity: AIASSIST_FIELDS_ENTITY_NAME,
  label: 'AI Assist Fields',
};

export const FUNCTIONS_NAMESPACE = 'functions';
export const AIASSIST_FUNCTIONS_NAMESPACE = 'aiassist';
